import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedApiServiceService {
  url: String = environment.serverurl;

  constructor(private http: HttpClient) { }

  createUserActivityTracker(req: {
    activity_type: String,
    activity_message: String,
    username: String,
    password: String,
    firstname: String,
    lastname: String,
    companyname: String,
    usertype: String,
    userdata: Object
  }): Observable<any> {
    return this.http.post(`${this.url}/machinemaster/user_activity_tracker/create`, req);
  }


}
